import { useContext } from "react";
import { OrderContext } from "../../store/OrderContext";
import { Link } from "react-router-dom";
import { getFormattedDate } from "../../utils/getFormattedDate";

const BusinessOrderList = () => {
  const { orders } = useContext(OrderContext);

  const orderList = orders.map((order) => {
    const date = getFormattedDate(order.createdAt);
    const orderStatus =
      order.status === "Done"
        ? "Finished"
        : order.status === "Canceled"
          ? "Canceled"
          : "Pending";
    return (
      <Link
        to={`/dashboard/business/orders/${order.id}`}
        key={order.id}
        className="invisable-btn info-card info-card-clickable business-order-card"
      >
        <h3 className="header-wrap">{order.id}</h3>
        <p>{date}</p>
        <p>{orderStatus}</p>
        <p>{order.totalPrice} kr</p>
      </Link>
    );
  });

  return (
    <div>
      <h2 style={{ marginBottom: "1rem" }}>Orders</h2>
      <div className="info-card-flexbox">
        {orderList.length > 0 ? (
          orderList
        ) : (
          <p>Once you've placed an order you will be able to see it here.</p>
        )}
      </div>
    </div>
  );
};

export default BusinessOrderList;
